mutation createUser($input: CreateUserInput!) {
  createUser(input: $input) {
    id
    firstname
    lastname
    email
    phone
    role {
      id
      name
      slug
    }
  }
}
